// --- START PATCH: Cart context type definition with optimistic methods ---
import { createContext } from "react";

export type CartContextType = {
  count: number;
  refresh: () => Promise<void>;
  /** Optimistically increment badge count by delta (for immediate UI update after add-to-cart) */
  increment: (delta: number) => void;
  /** Optimistically reset badge count to 0 (for immediate UI update after order placement) */
  reset: () => void;
};

export const CartContext = createContext<CartContextType | undefined>(undefined);
// --- END PATCH: Cart context type definition with optimistic methods ---
